import React from 'react';

const TextField = ({settings, ...props}) => {
  return (
    <input type="text" {...props}/>
  );
};

export default TextField;
